import { Link } from 'react-router-dom';

export interface Crumb {
  name: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-5">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs md:text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={`${item.name}-${index}`} className="flex items-center gap-2">
            {index > 0 && <span className="text-foreground-300">/</span>}
            {item.path ? (
              <Link to={item.path} className="transition-colors hover:text-primary-600">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}